import { useEffect, useState } from "react";
import { toast } from "sonner";
import { NplMap } from "../components/NplMap";
import { Card, PageHeader } from "../components/ui";
import { api, errMsg } from "../lib/api";
import { fmtIDR } from "../lib/format";

function RegionTable({ rows, label, testId }: { rows: any[]; label: string; testId: string }) {
  const sorted = [...rows].sort((a, b) => b.score - a.score || b.total - a.total);
  return (
    <div className="overflow-x-auto">
      <table className="yt-table" data-testid={testId}>
        <thead><tr><th>{label}</th><th className="text-right">Pinjaman</th><th className="text-right">Outstanding</th>{[1, 2, 3, 4, 5].map((c) => <th key={c} className="text-right">Col {c}</th>)}</tr></thead>
        <tbody>
          {sorted.map((r) => (
            <tr key={r.name}>
              <td className="font-medium">{r.name}</td>
              <td className="num text-right">{r.total}</td>
              <td className="num text-right">{fmtIDR(r.outstanding)}</td>
              {[1, 2, 3, 4, 5].map((c) => <td key={c} className={`num text-right ${c === 5 && r.cols["5"] ? "text-red-700 font-bold" : ""}`}>{r.cols[String(c)] || "-"}</td>)}
            </tr>
          ))}
          {sorted.length === 0 && <tr><td colSpan={8} className="text-center text-muted-foreground">Belum ada data wilayah</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export default function NplMapPage() {
  const [maps, setMaps] = useState<any>(null);
  useEffect(() => { api.get("/dashboard/npl-map").then((r) => setMaps(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!maps) return <div className="text-sm text-muted-foreground">Memuat peta…</div>;
  return (
    <div className="space-y-6" data-testid="npl-map-page">
      <PageHeader title="NPL Map" subtitle="Sebaran kolektibilitas per wilayah · prefektur penempatan di Jepang & provinsi asal di Indonesia · semakin merah pekat = semakin banyak Col 5" />
      <Card title="Jepang · Prefektur Penempatan" testId="npl-map-card-japan">
        <div className="grid lg:grid-cols-12 gap-4">
          <div className="lg:col-span-7"><NplMap kind="japan" data={maps.japan} testId="npl-map-japan" /></div>
          <div className="lg:col-span-5"><RegionTable rows={maps.japan} label="Prefektur" testId="npl-map-japan-table" /></div>
        </div>
      </Card>
      <Card title="Indonesia · Provinsi Asal" testId="npl-map-card-indonesia">
        <div className="grid lg:grid-cols-12 gap-4">
          <div className="lg:col-span-7"><NplMap kind="indonesia" data={maps.indonesia} testId="npl-map-indonesia" /></div>
          <div className="lg:col-span-5"><RegionTable rows={maps.indonesia} label="Provinsi" testId="npl-map-indonesia-table" /></div>
        </div>
      </Card>
    </div>
  );
}
